/**
 * The page's own heading, or its main area when it has none, as a place for focus to go when the control that held it is gone, such as
 * the button on a row that a confirmed action has just removed. A dialog's `fallbackFocus` takes it.
 */
export function pageHeading(): HTMLElement | null {
  return document.querySelector<HTMLElement>("main h1, h1") ?? document.querySelector("main");
}
